<script setup lang="ts">
import PrimeButton from 'primevue/button';
import PrimeInputText from 'primevue/inputtext';

type Props = {
  title: string;
  subtitle: string;
};

defineProps<Props>();
</script>

<template>
  <section class="mailing-list">
    <h2 class="mailing-list__title">{{ title }}</h2>
    <p class="mailing-list__subtitle">{{ subtitle }}</p>

    <!-- https://vismo.io/mail-list-confirm -->
    <form
      class="mailing-list__form"
      method="POST"
      action="https://f217e6e8.sibforms.com/serve/MUIFAK2YuEQSmSL8D9WPkvdMs9ReLdk-6oO4mc8LXSVJQs18xrp36mDQ7mcpfyvbb-ptTHF-HsYtuTTzvngCC5Fj3OwQRL70x3xDJEAfXn5ccThwgHQE1Rf1Qxc9acvkPoIsyN0ruPzIQBtqSMe2ZKQqVpMLFzKjVN7HfIyy7b9MdLLfdP8Ft_cQBvXW8bVKQqBa0sXrHgXVAZJd"
    >
      <PrimeInputText
        id="EMAIL"
        name="EMAIL"
        type="email"
        autocomplete="off"
        placeholder="jean-luc@example.com"
        required
      />
      <PrimeButton type="submit" label="Subscribe" />
      <input type="hidden" name="email_address_check" value="" />
      <input type="hidden" name="locale" value="en" />
      <input type="hidden" name="html_type" value="simple" />
    </form>
  </section>
</template>

<style scoped lang="scss">
@use '../assets/styles/_globals.scss' as g;

.mailing-list {
  width: 100%;
  padding: 3rem 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  background: light-dark(var(--p-surface-0), var(--p-surface-900));

  @media (max-width: g.$mobile-breakpoint) {
    padding: 3rem 2rem;
  }

  &__title {
    font-size: 2rem;
    font-weight: 800;
  }

  &__subtitle {
    font-size: 1.2rem;
    font-weight: 300;
  }

  &__form {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;

    @media (max-width: g.$mobile-breakpoint) {
      flex-direction: column;
    }
  }
}
</style>
